// extracted by mini-css-extract-plugin
export default {"popover-root":"G7j5iHhQz2c0J9BTaDKM","content":"sRCFHPjzmqQR7kKOKigB","arrow":"y7S_bYUA1xNSwmAk0GTu","popper":"woJ_XsLkuIUc65mNfzQw"};